import { ReactElement } from "react";
import { Paragraph } from "@twilio-paste/core/paragraph";
import { Button } from "@twilio-paste/core/button";
import {
  ChatButtonToolType,
  EmptyStateVariant,
} from "@twiliointernal/e2-commons-shared-definitions";
import { PromptLibraryEmptyStateProps, copy } from "../definitions";
import { EmptyState } from "@twiliointernal/e2-commons-shared-ui";

const PromptLibraryEmptyState = ({
  handleChatButtonToolClick,
  handleClosePromptLibrary,
}: PromptLibraryEmptyStateProps): ReactElement => {
  const onCreateSavedPromptClickHandler = () => {
    if (handleChatButtonToolClick) {
      handleChatButtonToolClick(ChatButtonToolType.PROMPT_LIBRARY_TRIGGER);
      handleClosePromptLibrary(false);
    }
  };
  return (
    <EmptyState
      variant={EmptyStateVariant.create}
      heading={copy.heading}
      description={""}
      children={
        <Paragraph>
          {copy.text.getStarted}{" "}
          <Button variant="link" onClick={onCreateSavedPromptClickHandler}>
            {copy.text.link}
          </Button>
        </Paragraph>
      }
    />
  );
};

export default PromptLibraryEmptyState;
